import script from "./NewsfeedDeleteCommentReplyConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsfeedDeleteCommentReplyConfirmModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__